'use strict'

const hueTheme = {
  primary: '#fff',
  appColor: '#364962',
  canvasColor: '#323235',
  canvasBg: '#fff',
  sidebarBg: '#F5F6F4',
  hoverColor: '#e5e5e5',
  comment: '#fdffe4',
  checkbox: '#00D9AD',
  selectionColor: '#e4f2ff',
  textSelection: '#e4f2ff',
  book: '#F7F8FA',
  bookHover: '#e4f2ff',
  bookIcon: '#364962',
  scrollBarColor: '#eee',
  scrollBarThumbColor: '#ddd',
  scrollBarThumbHover: '#bbb',
  project: '#ECEDF1',
  projectHover: '#F1F1F5',
  imageShadow: '#e7e7e7'
}

const darkTheme = {
  primary: '#201D25',
  appColor: '#EAEAEA',
  canvasColor: '#EAEAEA',
  canvasBg: '#201D25',
  sidebarBg: '#27292E',
  hoverColor: '#121314',
  comment: '#121314',
  checkbox: '#F2C94C',
  selectionColor: '#F2C94C87',
  textSelection: '#F2C94C87',
  book: '#27292E',
  bookHover: '#121314',
  bookIcon: '#F2C94C',
  scrollBarColor: '#333',
  scrollBarThumbColor: '#000',
  scrollBarThumbHover: '#222',
  project: '#121314',
  projectHover: '#1b1b1e',
  imageShadow: '#000'
}

export default {
  modes: {
    Paperless: 'Paperless',
    'Paper shape': 'Paper shape'
  },

  columns: {
    Wide: '950',
    Normal: '750',
    Narrow: '550'
  },

  lineHeights: {
    1.5: 1.5,
    1.6: 1.6,
    1.7: 1.7,
    1.8: 1.8,
    1.9: 1.9
  },

  fontSizes: {
    Small: '14px',
    Medium: '15px',
    Large: '16px',
    'Extra Large': '17px'
  },

  fontFamilies: {
    Archia: 'Archia',
    'Basier Circle': 'Basier Circle',
    Lato: 'Lato',
    Lora: 'Lora',
    'Overpass Mono': 'Overpass Mono',
    Poppins: 'Poppins',
    'PT Sans': 'PT Sans',
    'Silka mono': 'Silka mono',
    'Crimson Text': 'Crimson Text',
    'Courier Prime': 'Courier Prime',
    Inter: 'Inter',
    'Jetbrains Mono': 'Jetbrains Mono'
  },

  themes: {
    Magenta: {
      ...hueTheme,
      appColor: '#323232',
      hoverColor: '#F3F5F7',
      mainColor: '#3F40F2',
      linkColor: '#3F40F2',
      checkbox: '#3F40F2',
      selectionColor: '#F3F5F7',
      bookHover: '#F1F3F5',
      bookIcon: '#323232'
    },

    'Light Orange': {
      ...hueTheme,
      mainColor: '#FF5F11',
      linkColor: '#FF5F11',
      checkbox: '#FF5F11'
    },

    'Light Blue': {
      ...hueTheme,
      mainColor: '#005DDA',
      linkColor: '#005DDA',
      checkbox: '#005DDA'
    },

    'Light Green': {
      ...hueTheme,
      mainColor: '#00E841',
      linkColor: '#00E841',
      checkbox: '#00E841',
      selectionColor: '#50E77A',
      textSelection: '#50E77A'
    },

    'Light Pink': {
      ...hueTheme,
      mainColor: '#FB2DE6',
      linkColor: '#FB2DE6',
      checkbox: '#FB2DE6',
      selectionColor: '#FFD2FB',
      textSelection: '#FFD2FB'
    },

    'Dark Purple': {
      ...darkTheme,
      mainColor: '#7F39FB',
      linkColor: '#7F39FB',
      checkbox: '#7F39FB',
      selectionColor: '#7F39FB',
      textSelection: '#7F39FB',
      bookIcon: '#7F39FB'
    },

    'Dark Orange': {
      ...darkTheme,
      mainColor: '#FF5F11',
      linkColor: '#FF5F11',
      checkbox: '#FF5F11',
      selectionColor: '#FF5F11',
      textSelection: '#FF5F11',
      bookIcon: '#FF5F11'
    },

    'Dark Blue': {
      ...darkTheme,
      mainColor: '#08A9F7',
      linkColor: '#08A9F7',
      checkbox: '#08A9F7',
      selectionColor: '#08A9F7',
      textSelection: '#08A9F7',
      bookIcon: '#08A9F7'
    },

    'Dark Green': {
      ...darkTheme,
      mainColor: '#00FF47',
      linkColor: '#00FF47',
      checkbox: '#00FF47',
      selectionColor: '#03D33D',
      textSelection: '#03D33D',
      bookIcon: '#00FF47'
    },

    Poseidon: {
      ...hueTheme,
      appColor: '#323235',
      canvasColor: '#323235',
      mainColor: '#08A9F7',
      linkColor: '#08A9F7',
      checkbox: '#08A9F7',
      selectionColor: '#D6F1FF',
      textSelection: '#D6F1FF',
      bookHover: '#D6F1FF',
      project: '#D6F1FF',
      projectHover: '#def4ff'
    },

    Dracula: {
      primary: '#282A36',
      mainColor: '#50fa7b',
      linkColor: '#bd93f9',
      checkbox: '#50fa7b',
      appColor: '#f8f8f2',
      canvasColor: '#f8f8f2',
      selectionColor: '#10111c',
      textSelection: '#c5a4f5',
      canvasBg: '#282a36',
      sidebarBg: '#21222c',
      hoverColor: '#44475a',
      book: '#21222c',
      bookHover: '#10111c',
      comment: '#121314',
      scrollBarColor: '#333',
      scrollBarThumbColor: '#21222c',
      scrollBarThumbHover: '#000',
      project: '#282a36',
      projectHover: '#282a36',
      imageShadow: '#282a36',
      bookIcon: '#364962'
    }
  }
}
